import { ROUTE_GOVCRM_CONTACTS } from '../../constants';

export const CRM_EMAIL_LINK_KINDS = Object.freeze({
  NONE: 'none',
  FILTER: 'filter',
  STRIP: 'strip',
  SWITCH: 'switch',
  NO_ACCESS: 'no-access',
});

const ORG_PARAM = 'org';
const ASSIGNED_PARAM = 'assigned';
const ASSIGNED_ME = 'me';

const sameOrganization = (membership, org) => String(membership.organizationId) === org;

export function readCrmEmailLink(search, authUser) {
  const params = new URLSearchParams(search || '');
  const org = params.get(ORG_PARAM) || '';
  const assignedToMe = params.get(ASSIGNED_PARAM) === ASSIGNED_ME;
  if (!org && !assignedToMe) return { kind: CRM_EMAIL_LINK_KINDS.NONE };

  const organizations = authUser?.organizations || [];
  const active = organizations.find((membership) => membership.active);
  if (!org || (active && sameOrganization(active, org))) {
    return { kind: assignedToMe ? CRM_EMAIL_LINK_KINDS.FILTER : CRM_EMAIL_LINK_KINDS.STRIP };
  }

  const membership = organizations.find((item) => sameOrganization(item, org));
  if (!membership || membership.disabled) return { kind: CRM_EMAIL_LINK_KINDS.NO_ACCESS };
  return {
    kind: CRM_EMAIL_LINK_KINDS.SWITCH,
    organizationId: membership.organizationId,
    organizationName: membership.name,
  };
}

export function stripCrmEmailLink(location, history) {
  const params = new URLSearchParams(location.search || '');
  params.delete(ORG_PARAM);
  params.delete(ASSIGNED_PARAM);
  const search = params.toString();
  history.replace({ pathname: location.pathname, search: search ? `?${search}` : '', state: location.state });
}

export function holdsPermissionRedirect(location, authUser) {
  return (
    location.pathname === ROUTE_GOVCRM_CONTACTS.path &&
    readCrmEmailLink(location.search, authUser).kind === CRM_EMAIL_LINK_KINDS.SWITCH
  );
}
